import type { McpToken, McpTokenCreated, McpTokenPayload } from "../types";
import { api } from "./core";

export const mcpTokensApi = {
  mcpTokens: () => api<McpToken[]>("/mcp/tokens"),
  createMcpToken: (payload: McpTokenPayload) =>
    api<McpTokenCreated>("/mcp/tokens", { method: "POST", body: JSON.stringify(payload) }),
  revokeMcpToken: (id: string) => api<void>(`/mcp/tokens/${id}`, { method: "DELETE" }),
};
